// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 374) return "static/chunks/374-25f1b46fe73a6d02.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"140":"1e78b08f","239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"140":"5f0639cde6c544d9","239":"94747f0eb297ea7e","553":"dea20a29ca447610","863":"a2dff5e55c90766e","905":"1d157b7d3ea451af"}[chunkId] + ".js";
};